module.exports = __webpack_public_path__ + "static/media/CAMARONEMP_MENU-normal.4c2ba5e4.png";